module.exports = __webpack_public_path__ + "media/images/logo_child-trends-d65fad210faac17da0adb317ae124ad0.png";